<template></template>

<script>
  import 'jquery-validation'
  import 'select2/dist/js/select2.min.js'
  
  export default {
    name: 'RegisterArticle',
    mounted() {
      /**
       * Init Select2 for countries
       */
      const countries = $('.search-research-lines')
      
      countries.select2({
        language: {
          noResults: function() {
            return 'Aún no ha ingresado ningún valor'
          },
        },
      })

      /**
       * Init JQuery validation
       */
      $(() => {
        const $form = $('#article-form')

        $form.validate({
          ignore: [],
          highlight: function (element, errorClass, validClass) {
            $(element).addClass('is-invalid')
          },
          unhighlight: function (element, errorClass, validClass) {
            $(element).removeClass('is-invalid')
          },
          errorPlacement: function (label, element) {
            if (element.hasClass('select2-input')) {
              label.insertAfter(element.siblings('span.select2'))
            }
            else if (element.hasClass('form-check-input')) {
              label.insertAfter(element.parent())
            }
            else {
              label.insertAfter(element)
            }
            
            label.addClass('invalid-feedback')
          },
          rules: {
            citation: {
              required: true,
            },
            classification: {
              required: true,
            },
            year: {
              required: true,
            },
            is_related_development: {
              required: true,
            },
            participation_type: {
              required: true,
            },
            research_line_id: {
              required: true,
            },
            another_line: {
              required: function () {
                return $('select[name="research_line_id"] option:selected').text() === 'Otra'
              },
            },
            research_subline_id: {},
            voucher: {
              required: function () {
                if($(':hidden[name="current_voucher"]').val()) {
                  return false
                }
                
                return true
              },
            },
          },
          messages: {
            citation: {
              required: 'Este campo es requerido.',
            },
            classification: {
              required: 'Este campo es requerido.',
            },
            year: {
              required: 'Este campo es requerido.',
            },
            is_related_development: {
              required: 'Este campo es requerido.',
            },
            participation_type: {
              required: 'Este campo es requerido.',
            },
            research_line_id: {
              required: 'Este campo es requerido.',
            },
            another_line: {
              required: 'Este campo es requerido.',
            },
            research_subline_id: {},
            voucher: {
              required: 'Este campo es requerido.',
            },
          },
          submitHandler (form) {
            $('#btn-save, #btn-cancel').prop('disabled', true)
            $('#btn-save').find('.spinner-border').removeClass('d-none')
            
            $('#reported_date').prop('disabled', false)
            
            form.submit()
          },
        })
      
        $form.removeClass('invisible')

        
        $('#btn-cancel').on('click', (e) => {
          e.preventDefault()
          
          history.back()
        })

        /**
         * Show and hide another research line
         */
        collapseOtherLineInput($('select[name="research_line_id"] option:selected').text())

        $('select[name="research_line_id"]').on('change', function() {
          collapseOtherLineInput($('select[name="research_line_id"] option:selected').text())
        })
  
        function collapseOtherLineInput(value) {
          if (value === 'Otra') {
            $('#another-line-input').removeClass('d-none')
          } else {
            $('#another-line-input').addClass('d-none')
          }
        }
      })
    },
  }
</script>
